'use strict';

import InterNACHI from 'shared/InterNACHI';

window.InterNACHI = InterNACHI;
